import React from "react";
import PropTypes from "prop-types";
import TopNav from "./TopNav";
import { DomainScopes } from "../../constants/DomainConstants";
import Row from "../common/Row";
import HeaderRightFunction from "./HeaderRightFunction";
import { getHeaderItems } from "./NavItemHelper";

const PageHeader = ({ title, intro, showTopNav, topNavTabSettings, scope, transactionId, isReadOnly }) => {
	const titleItem = title ? <h1 className={scope === DomainScopes.NIEUWESPORTCLUB ? "nieuweSportclub-page-title" : "page-title"}>{title > 100 ? title.substring(0, 10) : title}</h1> : null;
	const introItem = intro ? scope === DomainScopes.FEDERATIE ? <Row>{intro}</Row> : <div className="page-subtitle">{intro}</div> : null;
	const items = getHeaderItems(topNavTabSettings, transactionId);
	const topItems = items.filter(i => i.showAsSideNav === false);
	const sideItems = items.filter(i => i.showAsSideNav === true);
	const topNav = showTopNav ?
		<TopNav
			topNavTabSettings={topItems}
			scope={scope}
			transactionId={transactionId}
			isReadOnly={isReadOnly} /> : null;

	const rightNav = showTopNav ?
		<HeaderRightFunction
			items={sideItems}
			scope={scope}
			transactionId={transactionId} /> : null;

	return (
		<section className="o-page__header">
			<div className="c-container u-clear" style={{ width: '100rem', maxWidth: '58rem' }}>
				<Row>
					<div className="o-page__header__section" style={{ paddingRight: '0px' }}>
						<div className="o-col-10">
							{titleItem}
							{introItem}
						</div>
						<div className="o-col-2" style={{ float: 'right', margin: '0px' }}>
							{rightNav}
						</div>
					</div>
				</Row>
				{topNav}
			</div>
		</section>
	);
};

PageHeader.propTypes = {
	title: PropTypes.string,
	intro: PropTypes.string,
	showTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	transactionId: PropTypes.string,
	isReadOnly: PropTypes.bool
};

export default PageHeader;
